/* ==========================================================================
   OSERE — Iconos animados de la sección de promesas

   POR QUÉ ESTE ARCHIVO EXISTE Y NO SE CARGA SIEMPRE.

   El reproductor de Lottie pesa 168 KB. Es más que todo el CSS propio del tema
   junto, y sirve para tres iconos decorativos. Con el 70-80% del tráfico en
   móvil, cargarlo de entrada es cobrarle a la usuaria 168 KB por un adorno.

   Así que se carga solo cuando se cumplen las cuatro condiciones:

     1. Hay al menos un icono configurado  (lo decide el Liquid: sin iconos,
        este archivo ni se referencia)
     2. La sección ha entrado en pantalla
     3. La persona no pidió movimiento reducido
     4. La red no es lenta ni tiene el ahorro de datos activado

   Si falla cualquiera, no pasa nada: los huecos quedan vacíos y las promesas
   se leen igual. El icono NUNCA reserva altura por su cuenta, justamente para
   que su ausencia no deje un agujero en la maqueta.

   Es el mismo criterio que el bucle de vídeo del hero: la mejora se añade,
   nunca se resta de algo que ya funciona.
   ========================================================================== */

(function () {
  'use strict';

  var HUECOS = '[data-os-lottie]';
  var PLAYER = null; // se resuelve una vez y se reutiliza

  function movimientoReducido() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function redLenta() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return /(^|-)(2g|slow-2g)$/.test(c.effectiveType || '');
  }

  /* La ruta del reproductor la escribe Liquid en el propio <script>, así que
     se deduce de él en vez de quemarla aquí — el CDN de Shopify le pone un
     hash al nombre y una ruta fija se rompería en el siguiente despliegue. */
  function rutaReproductor() {
    var yo = document.querySelector('script[src*="os-promesas"]');
    if (!yo) return null;
    return yo.src.replace(/os-promesas\.js/, 'os-lottie.min.js');
  }

  function cargarReproductor() {
    if (PLAYER) return PLAYER;
    PLAYER = new Promise(function (resolver, rechazar) {
      if (window.lottie) return resolver(window.lottie);
      var ruta = rutaReproductor();
      if (!ruta) return rechazar();
      var s = document.createElement('script');
      s.src = ruta;
      s.async = true;
      s.onload = function () { window.lottie ? resolver(window.lottie) : rechazar(); };
      s.onerror = rechazar;
      document.head.appendChild(s);
    });
    return PLAYER;
  }

  function montar(hueco, lottie) {
    var url = hueco.getAttribute('data-os-lottie');
    if (!url || hueco.dataset.osMontado) return;
    hueco.dataset.osMontado = '1';
    try {
      lottie.loadAnimation({
        container: hueco,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: url
      });
      /* Solo se le da altura cuando ya hay algo que enseñar. Si se la diéramos
         en el CSS, un fallo de red dejaría un hueco en blanco. */
      hueco.setAttribute('data-os-listo', '');
    } catch (e) {
      hueco.removeAttribute('data-os-montado');
    }
  }

  function arrancar(seccion) {
    var huecos = seccion.querySelectorAll(HUECOS);
    if (!huecos.length) return;
    cargarReproductor()
      .then(function (lottie) {
        Array.prototype.forEach.call(huecos, function (h) { montar(h, lottie); });
      })
      .catch(function () {
        /* Sin reproductor no hay iconos, y ya está. No se avisa a nadie: es
           decoración, no contenido. */
      });
  }

  function init() {
    if (movimientoReducido() || redLenta()) return;

    var secciones = document.querySelectorAll('.os-promesas');
    if (!secciones.length) return;

    if (!('IntersectionObserver' in window)) {
      // Sin observer, se cargan sin más: el navegador es viejo pero la sección
      // existe y los iconos son parte de cómo se ve.
      Array.prototype.forEach.call(secciones, arrancar);
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.unobserve(e.target);
          arrancar(e.target);
        });
      },
      { rootMargin: '200px 0px' } // un poco antes de entrar, para que no se vea aparecer
    );

    Array.prototype.forEach.call(secciones, function (s) { obs.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
